import { render, staticRenderFns } from "./refresh-button.vue?vue&type=template&id=2f4658f7&scoped=true&"
import script from "./refresh-button.vue?vue&type=script&lang=js&"
export * from "./refresh-button.vue?vue&type=script&lang=js&"
import style0 from "./refresh-button.vue?vue&type=style&index=0&id=2f4658f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4658f7",
  null
  
)

export default component.exports